import { createSlice } from "@reduxjs/toolkit";

export const profileSlice= createSlice({
    name:"profile",
    initialState:{
        user:[],
        token:""
    },
    reducers:{
        setUserProfile:(state,action)=>{
            state.user =action.payload
        },
        // setTokens:(state,action)=>{
        //     state.token =action.payload
        // }
    }
})

export const {setUserProfile} = profileSlice.actions;
export default profileSlice.reducer;